import Vue from 'vue'
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist'
import getters from './getters';
import * as actions from './actions';
import mutations from './mutations';
import {state} from './state';

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
    key: 'my-app',
    storage: window.localStorage
});

const store = new Vuex.Store({
    strict: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters,
    plugins: [vuexPersist.plugin]
});

export default store
